import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class PedidoService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerPedidos(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: pedidoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            pedido {
              obtenerPedidos(
                entidad: $entidad,
                paginaActual: $paginaActual,
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    activo
                    clienteNombre
                    cliente_proveedor_rut
                    bloqueado
                    codigo
                    comuna
                    direccion
                    direccion_codigo
                    empresa_rut
                    es_boleta
                    fecha_registro
                    numero_pedido
                    provincia
                    region
                    vendedor_codigo
                    vendedor_nombre
                    monto_dscto
                    monto_total
                    clienteActivo
                    monto_total_iva
                    total_bruto
                    monto_neto
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.pedido.obtenerPedidos;
            callback({ mensajes, respuesta });
        });
    }
    obtenerPedidosDesactivados(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($empresa_rut: Decimal, $sucursal_codigo: Decimal, $vendSel: [vendedorInputType], $fechaInicio: String, $fechaTermino: String, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            pedido {
              obtenerPedidosDesactivados(
                empresa_rut: $empresa_rut
                sucursal_codigo: $sucursal_codigo
                vendSel: $vendSel
                fechaInicio: $fechaInicio
                fechaTermino: $fechaTermino
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    numero_pedido
                    tieneProductosInactivos
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.pedido.obtenerPedidosDesactivados;
            callback({ mensajes, respuesta });
        });
    }
    obtenerPedidosDetalle(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($empresa_rut: Decimal, $sucursal_codigo: Decimal, $vendSel: [vendedorInputType], $fechaInicio: String, $fechaTermino: String, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            pedido {
              obtenerPedidosDetalle(
                empresa_rut: $empresa_rut
                sucursal_codigo: $sucursal_codigo
                vendSel: $vendSel
                fechaInicio: $fechaInicio
                fechaTermino: $fechaTermino
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    activo
                    producto_activo
                    clienteNombre
                    cliente_proveedor_rut
                    bloqueado
                    codigo
                    comuna
                    direccion
                    direccion_codigo
                    empresa_rut
                    es_boleta
                    fecha_registro
                    numero_pedido
                    provincia
                    region
                    vendedor_codigo
                    vendedor_nombre
                    monto_dscto
                    monto_total
                    clienteActivo
                    monto_total_iva
                    monto_total
                    total_bruto
                    cantidad
                    nombreFormato
                    precio_unitario
                    skuProducto
                    descripcionProducto
                    montoDescuentoGlobalTotal
                    monto_descuento
                    monto_neto
                    producto_activo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.pedido.obtenerPedidosDetalle;
            callback({ mensajes, respuesta });
        });
    }
    obtenerPedidosXLSDetalle(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($empresa_rut: Decimal, $sucursal_codigo: Decimal, $vendSel: [vendedorInputType], $fechaInicio: String, $fechaTermino: String, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            pedido {
              obtenerPedidosExcel(
                empresa_rut: $empresa_rut
                sucursal_codigo: $sucursal_codigo
                vendSel: $vendSel
                fechaInicio: $fechaInicio
                fechaTermino: $fechaTermino
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.pedido.obtenerPedidosExcel;
            callback({ mensajes, respuesta });
        });
    }
    eliminar(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          mutation ($entidad: pedidoInputType) {
            pedido {
              eliminar(entidad: $entidad) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.pedido.eliminar;
            callback({ mensajes, respuesta });
        });
    }
    obtenerPedidosXLSResumen(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($empresa_rut: Decimal, $sucursal_codigo: Decimal, $vendSel: [vendedorInputType], $fechaInicio: String, $fechaTermino: String, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            pedido {
              obtenerPedidosExcelResumen(
                empresa_rut: $empresa_rut
                sucursal_codigo: $sucursal_codigo
                vendSel: $vendSel
                fechaInicio: $fechaInicio
                fechaTermino: $fechaTermino
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.pedido.obtenerPedidosExcelResumen;
            callback({ mensajes, respuesta });
        });
    }
    obtenerPedido(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($empresa_rut: Decimal, $codigo: Int) {
            pedido {
              obtenerPedido(empresa_rut: $empresa_rut, codigo: $codigo) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  cabecera {
                    activo
                    clienteNombre
                    cliente_proveedor_rut
                    codigo
                    comuna
                    direccion
                    direccion_codigo
                    empresa_rut
                    es_boleta
                    fecha_registro
                    numero_pedido
                    provincia
                    region
                    vendedor_codigo
                    monto_dscto
                    monto_total
                    total_bruto
                    monto_total_iva
                  }
                  detallePedido {
                    pedido_codigo
                    producto_codigo
                    formato_codigo
                    empresa_rut
                    cantidad
                    monto_descuento
                    monto_descuento_maximo
                    monto_total_sin_flete
                    nombreProducto
                    nombreFormato
                    precio_unitario
                    monto_neto
                    monto_bruto
                    monto_iva_det
                    sku
                    estado_producto
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.pedido.obtenerPedido;
            callback({ mensajes, respuesta });
        });
    }
    conviertePedidosEnNotaVenta(inputParams, callback) {
        this.gqlclient.mutate({
            mutation: gql `
          mutation ($rutEmpresa: Decimal, $sucursalCodigo: Decimal, $rutUsuario: Decimal, $listaPedidos: [pedidolistaInputType]) {
            pedido {
              conviertePedidosEnNotaVenta(rutEmpresa: $rutEmpresa, sucursalCodigo: $sucursalCodigo, rutUsuario: $rutUsuario, listaPedidos: $listaPedidos) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  cabecera {
                    direccion_cliente_rut
                    direccion_codigo
                    sucursal_codigo
                    rut_empresa
                    folio
                    nombrecliente
                    direccion_cliente_rut
                    total
                    tipo_dte_codigo
                    condicion_pago_codigo
                    estado_documento_codigo
                    vendedor_codigo
                    rut_usuario_registro
                    fecha_emision
                    observacion_1
                    observacion_2
                    fecha_registro
                    folio_transformado
                    tipo_dte_codigo_transformado
                    totalBruto
                  }
                  detalle {
                    rut_empresa
                    cantidad
                    cantidad_atendida
                    descuento
                    es_porcentaje_descuento
                    folio
                    formato_codigo
                    linea
                    monto_iva
                    monto_total
                    precio_neto
                    precio_unitario
                    producto_codigo
                    tipo_dte_codigo
                    tipo_dte_codigo
                  }
                  pedidoConvertido
                  logErrores {
                    codigo
                    contexto
                    texto
                    tipo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.pedido.conviertePedidosEnNotaVenta;
            callback({ mensajes, respuesta });
        });
    }
    verificarArchivo(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: pedidoInputType) {
            pedido {
              verificarArchivo(entidad: $entidad) {
                respuesta
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.pedido.verificarArchivo;
            callback({ mensajes, respuesta });
        });
    }
    guardarArchivo(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: pedidoInputType) {
            pedido {
              guardarPedidosArchivo(entidad: $entidad) {
                respuesta
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.pedido.guardarPedidosArchivo;
            callback({ mensajes, respuesta });
        });
    }
    generarPedidosDelArchivo(inputParams, callback) {
        this.gqlclient.mutate({
            mutation: gql `
          mutation ($entidad: ForkListaPedidoDTOInputType) {
            pedido {
              generarPedidos(entidad: $entidad) {
                respuesta {
                  exito
                  error
                  descripcion
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.pedido.generarPedidos;
            callback({ mensajes, respuesta });
        });
    }
}
PedidoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PedidoService_Factory() { return new PedidoService(i0.ɵɵinject(i1.GraphQLClient)); }, token: PedidoService, providedIn: "root" });
